import apiService from './apiService';

export interface AgentRule {
  id: number;
  title: string | null;
  rule_text: string;
  apply_voice: boolean;
  apply_whatsapp: boolean;
  enabled: boolean;
  sort_order: number;
  // Leer = "immer an"; nicht-leer = "proaktiv" (feuert bei diesen Events).
  trigger_events: string[];
  /** Agent scope: null = gilt für alle Agenten, sonst nur für diese Rufnummer. */
  phone_number: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface AgentRuleCreate {
  title?: string | null;
  rule_text: string;
  apply_voice?: boolean;
  apply_whatsapp?: boolean;
  enabled?: boolean;
  sort_order?: number;
  trigger_events?: string[];
  /** Leer/weggelassen = die Regel gilt für alle Agenten des Unternehmens. */
  phone_number?: string | null;
}

export interface AgentRuleUpdate {
  title?: string | null;
  rule_text?: string;
  apply_voice?: boolean;
  apply_whatsapp?: boolean;
  enabled?: boolean;
  sort_order?: number;
  trigger_events?: string[];
  /** "" setzt eine Regel zurück auf "gilt für alle Agenten". */
  phone_number?: string | null;
}

// Katalog der wählbaren Trigger-Events (Single Source of Truth im Backend).
export interface AgentRuleEvent {
  key: string;
  label: string;
  group: string;
}

class AgentRulesService {
  list(phoneNumber?: string | null): Promise<AgentRule[]> {
    // With an agent number: that agent's rules plus the ones that apply to
    // every agent. Without: everything the tenant has.
    const q = phoneNumber ? `?phone_number=${encodeURIComponent(phoneNumber)}` : '';
    return apiService.get<AgentRule[]>(`/agent-rules${q}`);
  }

  listEvents(): Promise<AgentRuleEvent[]> {
    return apiService
      .get<{ events: AgentRuleEvent[] }>('/agent-rules/events')
      .then((res) => res.events);
  }

  create(payload: AgentRuleCreate): Promise<AgentRule> {
    return apiService.post<AgentRule>('/agent-rules', payload);
  }

  update(id: number, payload: AgentRuleUpdate): Promise<AgentRule> {
    return apiService.patch<AgentRule>(`/agent-rules/${id}`, payload);
  }

  remove(id: number): Promise<{ ok: boolean }> {
    return apiService.delete<{ ok: boolean }>(`/agent-rules/${id}`);
  }
}

const agentRulesService = new AgentRulesService();
export default agentRulesService;
